import { type CSSProperties } from "react"
import { CellContext } from "@tanstack/react-table"

import { UITypes } from "types"

import styles from "./index.module.scss"

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
  thresholds?: { low: number; medium: number }
}

const getRateClassName = (rate: number | null, thresholds: { low: number; medium: number }) => {
  if (rate === null) return styles.rateNA
  if (rate <= thresholds.low) return styles.rateLow
  if (rate <= thresholds.medium) return styles.rateMedium
  return styles.rateHigh
}

const RateCell = ({ cell, thresholds = { low: 85, medium: 95 } }: Props) => {
  const rate = cell.getValue().value as number | null

  return (
    <div className={styles.rateCell}>
      <span className={styles.rateTrack}>
        <span
          className={`${styles.rateFill} ${getRateClassName(rate, thresholds)}`}
          style={{ "--rate-width": `${rate ?? 0}%` } as CSSProperties}
        />
      </span>
      <span>{rate === null ? "N/A" : `${rate}%`}</span>
    </div>
  )
}

export default RateCell
